import {IInsuranceProductModel} from "../../../models/insurance-product.model.interface";
import {BookingModel} from "../../../../booking.model";
import {INeatProductRawData} from "../raw-data/neat-raw-data.interfaces";
import {INeatInsuranceProductViewModel} from "./neat-insurance-product.view-model.interface";
import {NullableString} from "../../../../../../../types/nullable-types";
import {
    IInsuranceProductConfigurationViewModel
} from "../../../../../../configuration/objects/insurance-configuration.interfaces";
import {ISsrType} from "../../../../../../ssr-types/ssr-types.service.interface";
import {IServiceFactory} from "../../../../../../service-factory.interface";

import {IPassengerType} from "../../../../../../passenger-types/passengers-types.service.interface";

export class NeatInsuranceProductModel implements IInsuranceProductModel, INeatInsuranceProductViewModel {
    constructor(private readonly booking: BookingModel,
                public readonly providerCode: string,
                public readonly productRawData: INeatProductRawData,
                private readonly config: IInsuranceProductConfigurationViewModel) {

    }



    private get services(): IServiceFactory {
        return this.booking.services;
    }

    get id(): string {
        return this.productRawData.id;
    }

    get feeCode(): string {
        return this.config.feeCode;
    }
    get ssrCode(): ISsrType {
        return this.services.ssrTypes.getSsrType(this.config.ssrCode);
    }

    get quoteTitle(): string {
        return this.productRawData.title;
    }

    get quoteSubtitle(): string {
        return this.productRawData.subtitle;
    }

    get iconUrl(): string {
        return this.productRawData.icon;
    }

    get priceToDisplay(): string {
        return this.productRawData.premium_per_display;
    }

    get documentLinkHtml(): NullableString {
        const documents = this.productRawData?.documents ?? [];

        if(documents.length === 0) {
            return null;
        }

        const label = documents[0].label;
        const url = this.services.externalLinksConfiguration.travelConditions; //documents[0].url;

        return label?.replaceAll('{{documents.url}}', url) ?? null;
    }


    get totalPremium(): number {
        return this.productRawData.premium_gross;
    }

    buildFeeNoteParts(): string[] {
        return [this.productRawData.id];
    }

    getPremiumPerPassengerType(passengerType: IPassengerType): number {
        return this.productRawData.premium_display;
    }

    getInfantPremium(): number {
        return 0;
    }



/*
    private _isTheProductSelectedForPassenger(passenger: MaturePassengerModel): boolean {
        return passenger.fees.some(f => {
            const feeNote = f.insuranceNote;
            if(!feeNote) {
                return false;
            }

            const productNote = feeNote.fromProviderParts(this.providerCode, this.buildFeeNoteParts());

            return feeNote.equals(productNote);

        })
    }

 */
}